// extracted by mini-css-extract-plugin
export default {"scroll-top":"BackToTop_scroll-top__yUKe0","active":"BackToTop_active__GA-WS"};